var borders = {
    base: "1px solid",
};

export { borders as default };
//# sourceMappingURL=borders.js.map
